import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Feature } from 'src/app/kuba/features/models/features-base.model';
import { FoodSafetyServices } from '../../services/foodsafety.services';
import { foodSafetyZoneTabs } from '../../foodsafety-tabs';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';


@Component({
    selector: 'foodsafety-view',
    templateUrl: 'foodsafety-view.component.html',
  standalone: false
})

export class FoodsafetyViewComponent implements OnInit {
    pageTitle: string;
    zoneId:any;
    enabledAdditionalFeatures: any;
    additionalFeatures: any;
    fsId: number;
    initialPage: any;
    private subscriptions: Subscription[] = [];
    constructor(
        private route: Router,
        private activatedRoute: ActivatedRoute,
        private foodSafetyservices: FoodSafetyServices) {
        // The component is reused when only the zone id changes, for example
        // when another zone is picked in the hover sub-navigation.
        this.subscriptions.push(this.activatedRoute.params.subscribe(params => this.openZone(params['id'])));
        // Re-opening the same zone does not change the params, so the redirect to the
        // first tab runs after every navigation that lands on the zone itself.
        this.subscriptions.push(this.route.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe(() => this.openFirstTab()));
        // Entering Food Safety from another layout, such as the dashboard right after
        // login, creates this component only after its NavigationEnd has been emitted.
        if (this.route.currentNavigation() === null) {
            this.openFirstTab();
        }
    }

    private openZone(fsId: any) {
        this.fsId = fsId;
        this.subscriptions.push(this.foodSafetyservices.getFSZoneName(+this.fsId).subscribe(res =>{
            this.pageTitle = res[0].ZoneName;
            this.zoneId = res[0].Id;
            sessionStorage.setItem('ZoneName',this.pageTitle);
            sessionStorage.setItem('ZoneId',this.zoneId);
        }));
        this.enabledAdditionalFeatures = foodSafetyZoneTabs(JSON.parse(sessionStorage.getItem('workingModule'))?.children);
    }

    /** Opens the zone's first tab when the URL points at the zone itself. */
    private openFirstTab() {
        // A deep link, such as a tab picked in the hover sub-navigation, keeps its tab.
        if (this.enabledAdditionalFeatures.length > 0 && this.isAtZoneRoot()) {
            this.route.navigate([this.enabledAdditionalFeatures[0].linkText, { Id: this.fsId }],
                { relativeTo: this.activatedRoute });
        }
    }

    /** Whether the URL points at the zone itself rather than at one of its tabs. */
    private isAtZoneRoot(): boolean {
        const segments = this.route.url.split(/[?#]/)[0].split('/').filter(Boolean);
        return (segments[segments.length - 2] ?? '').split(';')[0] === 'details';
    }

    ngOnInit() { }

    BackToZone(){
        let foodSafety = this.activatedRoute.snapshot.data['list'];
        if(foodSafety.length == 1){
           sessionStorage.setItem('checkParent',this.activatedRoute.snapshot.data['parent']);
           this.route.navigate(['../../list'],  { relativeTo: this.activatedRoute });
        }
        this.route.navigate(['../../list'],  { relativeTo: this.activatedRoute });
    }

    ngOnDestroy() {
        this.subscriptions.forEach((sub, i) => {
            sub.unsubscribe();
        });
    }
}
